/*!

=========================================================
* Paper Dashboard PRO React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import MainPage from "views/LoggedUserPages/MainPage";
import ImportExcel from 'views/LoggedUserPages/DataImport/ImportFile/ImportExcel'
import FormsMain from 'views/LoggedUserPages/DataImport/Forms/FormsMain'
// import MedicalProceduresPricing from 'views/LoggedUserPages/MedicalProceduresPricing'
import NewRaport from 'views/LoggedUserPages/Raports/NewRaport'
import MyIndicatorsPage from 'views/LoggedUserPages/Indicators/MyIndicators/MyIndicatorsPage'
import IndicatorsPage from 'views/LoggedUserPages/IndicatorsPage'
import ManagementDashboardPage from 'views/LoggedUserPages/ManagementDashboard/ManagementDashboardPage'
import ProfilePage from 'views/LoggedUserPages/ProfilePage'
import UserDataPage from 'views/LoggedUserPages/UserDataPage'
import ComparativeIndicatorsPage from "views/LoggedUserPages/Indicators/ComparativeIndicators/ComparativeIndicatorsPage";
import Definition from "views/LoggedUserPages/medicalPricing/Definition";
import MedicalProceduresPricing from "views/LoggedUserPages/medicalPricing/MedicalProceduresPricing";

import MainEdit from "views/LoggedUserPages/DataImport/AddEditViews/MainEdit";
import ImportFiveFour from "views/LoggedUserPages/DataImport/ImportFiveFourFiles/ImportFiveFour";
import CalculateDataForm from "./views/LoggedUserPages/DataImport/Calculate/CalculateDataForm";




const routes = [
  {
    path: "/main_page",
    name: "Strona główna",
    icon: "nc-icon nc-bookmark-2",
    component: <MainPage />,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "Wprowadzanie danych",
    icon: "nc-icon nc-single-copy-04",
    state: "importCollapse",
    views: [
        {
        path: "/import_five_four",
        name: "Import słowników",
        mini: "1",
        component: <ImportFiveFour />,
        layout: "/admin",
      },
      {
        path: "/opk_edit",
        name: "Edycja Słowników",
        mini: "2",
        component: <MainEdit />,
        layout: "/admin",
      },
      {
        path: "/data_import",
        name: "Import Danych",
        mini: "3",
        component: <ImportExcel />,
        layout: "/admin",
      }, {
        path: "/calculate_data",
        name: "Rozliczenie kosztów",
        mini: "4",
        component: <CalculateDataForm />,
        layout: "/admin",
      },
    ]
  },
  {
    collapse: true,
    name: "Wycena procedur medycznych/usług",
    icon: "nc-icon nc-money-coins",
    state: "pricingCollapse",
      views:[
        {
          path: "/pricing_definition",
          name: "Definicje",
          mini: "1",
          component: <Definition />,
          layout: "/admin"
      },
       {
         path: "/pricing_med",
        name: "Wycena procedur medycznych/Usług",
        mini: "2",
        component: <MedicalProceduresPricing />,
        layout: "/admin"
      }]
    // path: "/pricing",
    // name: "Wycena procedur medycznych",
    // icon: "nc-icon nc-money-coins",
    // component: MedicalProceduresPricing,
    // layout: "/admin",
  },
  {
    path: "/raport",
    name: "Raporty",
    icon: "nc-icon nc-paper",
    component: <NewRaport />,
    layout: "/admin",
  },
  // {
  //   collapse: true,
  //   name: "Pages",
  //   icon: "nc-icon nc-book-bookmark",
  //   state: "pagesCollapse",
  //   views: [
      // {
      //   path: "/login",
      //   name: "Login",
      //   mini: "L",
      //   component: Login,
      //   layout: "/auth",
      // },
      // {
      //   path: "/register",
      //   name: "Register",
      //   mini: "R",
      //   component: RegisterPage,
      //   layout: "/auth",
      // },
      // {
      //   path: "/admin",
      //   name: "Register",
      //   mini: "R",
      //   component: BaseLayout,
      //   layout: "/auth",
      // },
  //   ],
  // },
  {
    path: "/management_dashboard",
    name: "Pulpit zarządczy​",
    icon: "nc-icon nc-briefcase-24",
    component: <ManagementDashboardPage />,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "Wskaźniki",
    icon: "nc-icon nc-chart-bar-32",
    state: "indicatorsCollapse",
    views: [
      {
        path: "/yourData",
        name: "Twoje Sprawozdania finansowe",
        component: <UserDataPage />,
        mini: "1",
        layout: "/admin",
      },
       {
          path: "/my_indicators",
          name: "Moje Wskaźniki",
          component: <MyIndicatorsPage />,
          mini: "2",
          layout: "/admin",
      },
       {
          path: "/comperative_indicators",
          name: "Benchmarking",
          component: <ComparativeIndicatorsPage />,
          mini: "3",
          layout: "/admin",
      },
      // {
      //     path: "/indicators",
      //     name: "Wskaźniki",
      //     component: IndicatorsPage,
      //     mini: "W",
      //     layout: "/admin",
      // },
    ]
  },
  {
    path: "/profile",
    name: "Profil użytkownika​",
    icon: "nc-icon nc-badge",
    component: <ProfilePage />,
    layout: "/admin",
  },

  
];

export default routes;
